export default __webpack_public_path__ + "static/media/atletico2.0fffefa8.jpg";